import { supabase } from "../supabase";

export interface MediaUsage {
  photos: number;
  videos: number;
  bytes: number;
}

/**
 * 保存中の写真・動画の件数と合計容量。ゴミ箱の分も含む
 * (ゴミ箱にある間もストレージは使われているため)。
 */
export async function fetchMediaUsage(): Promise<MediaUsage> {
  const { data, error } = await supabase.from("media").select("type, byte_size");
  if (error) throw error;
  const rows = data as { type: "photo" | "video"; byte_size: number }[];
  return rows.reduce<MediaUsage>(
    (usage, row) => ({
      photos: usage.photos + (row.type === "photo" ? 1 : 0),
      videos: usage.videos + (row.type === "video" ? 1 : 0),
      bytes: usage.bytes + row.byte_size,
    }),
    { photos: 0, videos: 0, bytes: 0 },
  );
}

export interface StorageStatus {
  usedBytes: number;
  limitBytes: number;
}

/**
 * 使用量とカップルごとの上限。アップロード前の残量表示に使う。
 * マイグレーション未適用の環境では null(表示を出さないだけ。強制は Worker 側)。
 */
export async function fetchStorageStatus(): Promise<StorageStatus | null> {
  const response = await supabase.rpc("storage_status");
  if (response.error) return null;

  const rows: unknown = response.data;
  const row: unknown = Array.isArray(rows) ? rows[0] : rows;
  if (typeof row !== "object" || row === null) return null;
  const status = row as { used_bytes?: unknown; limit_bytes?: unknown };
  if (typeof status.used_bytes !== "number" || typeof status.limit_bytes !== "number") {
    return null;
  }
  return { usedBytes: status.used_bytes, limitBytes: status.limit_bytes };
}
